// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as Category$Showside from "../../types/Category.bs.js";
import * as SimpleSlider$Showside from "../SimpleSlider.bs.js";
import * as DataAttribute$Showside from "../../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../../utils/ReactDOMUtils.bs.js";
import * as UseIsScrolling$Showside from "../../hook/UseIsScrolling.bs.js";
import * as UseDelayedHover$Showside from "../../hook/UseDelayedHover.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as EntrypointContext$Showside from "../../context/EntrypointContext.bs.js";
import * as UseSimulatedClick$Showside from "../../hook/UseSimulatedClick.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
function NavMenu__Topbar$HiddenLinkTree(Props) {
  var category = Props.category;
  var renderGroup = function (index, children) {
    if (children.length === 0) {
      return null;
    } else {
      return React.createElement("ul", {
        key: String(index),
        className: CSS$Showside.prefix("sr-only")
      }, Belt_Array.mapWithIndex(Belt_Array.keepMap(children, function (child) {
        var childrenOfChild = Category$Showside.getChildren(child);
        return Belt_Option.map(Category$Showside.getCategoryLink(child), function (link) {
          return [link, child.title, childrenOfChild];
        });
      }), function (i, param) {
        return React.createElement("li", {
          key: String(i),
          className: CSS$Showside.prefix("sr-only")
        }, React.createElement("a", {
          className: CSS$Showside.prefix("sr-only"),
          tabIndex: -1,
          href: param[0]
        }, param[1]), renderGroup(index + 1 | 0, param[2]));
      }));
    }
  };
  return renderGroup(1, Category$Showside.getChildren(category));
}
NavMenu__Topbar$HiddenLinkTree.displayName = "NavMenu__Topbar.HiddenLinkTree";
var make = React.memo(NavMenu__Topbar$HiddenLinkTree);
var HiddenLinkTree = {
  make: make
};
function NavMenu__Topbar$Item(Props) {
  var category = Props.category;
  var link = Props.link;
  var enableHiddenLinkTree = Props.enableHiddenLinkTree;
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onPureCategoryClick = match$1.onPureCategoryClick;
  var trackEvent = match$1.trackEvent;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var ref = React.useRef(null);
  var emptyRef = React.useRef(null);
  var isScrolling = UseIsScrolling$Showside.useIsScrolling(150, emptyRef);
  var isActive = Belt_Option.mapWithDefault(ctx.currentL1, false, function (c) {
    return c.id === category.id;
  });
  var match$2 = ctx.mode;
  var match$3 = UseDelayedHover$Showside.useDelayedHover(!ctx.isModalOpen, 100, match$2 || !(typeof link === "number" && !isScrolling) ? undefined : function (param) {
    Curry._2(onPureCategoryClick, false, category);
  });
  var handleItemMouseEnter = match$3.onMouseEnter;
  var match$4 = UseSimulatedClick$Showside.useTouch(true, undefined, function (e) {
    Curry._2(onPureCategoryClick, undefined, category);
  });
  var match$5 = ctx.mode;
  var handleItemTouchStart = typeof link === "number" && !match$5 ? match$4.onTouchStart : undefined;
  var match$6 = ctx.mode;
  var handleItemTouchMove = typeof link === "number" && !match$6 ? match$4.onTouchMove : undefined;
  var match$7 = ctx.mode;
  var handleItemTouchEnd = typeof link === "number" && !match$7 ? match$4.onTouchEnd : undefined;
  var tmp;
  tmp = typeof link === "number" || link.TAG === /* InternalLink */0 ? undefined : link._0.href;
  var href = Belt_Option.orElse(Belt_Option.flatMap(Category$Showside.Link.getCardFallbackLink(category), Category$Showside.Link.getURL), tmp);
  var handleItemClick = function (e) {
    var match = ctx.mode;
    if (typeof link === "number" && match) {
      e.preventDefault();
    }
    var match$1 = ctx.mode;
    if (typeof link === "number") {
      if (match$1) {
        return Curry._2(onPureCategoryClick, undefined, category);
      }
    } else if (link.TAG === /* InternalLink */0) {
      return Curry._1(link._0, undefined);
    }
    Curry.app(trackEvent, ["menu:link clicked", undefined, category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var target = match.config.settings.openLinkInNewTab ? "_blank" : undefined;
  var match$8 = ctx.mode;
  var tmp$1 = {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref),
    className: CSS$Showside.prefix(Cn.make(["p-0.5", "no-underline", "text-color-unset", "whitespace-nowrap", match$8 ? "border-b-2" : "border-b-3", link !== /* NoLink */0 ? "hover:underline" : "", "outline-none flex h-full items-center select-none", Belt_Option.isSome(href) ? "cursor-pointer" : "cursor-default", isActive ? "border-accent" : ctx.mode === /* Topbar */0 && handleItemMouseEnter !== undefined && href === undefined ? "border-transparent hover:border-accent" : "border-transparent"])),
    draggable: false,
    tabIndex: 0,
    onClick: handleItemClick,
    onMouseLeave: match$3.onMouseLeave
  };
  if (href !== undefined) {
    tmp$1.href = Caml_option.valFromOption(href);
  }
  if (target !== undefined) {
    tmp$1.target = Caml_option.valFromOption(target);
  }
  if (handleItemMouseEnter !== undefined) {
    tmp$1.onMouseEnter = Caml_option.valFromOption(handleItemMouseEnter);
  }
  if (handleItemTouchEnd !== undefined) {
    tmp$1.onTouchEnd = Caml_option.valFromOption(handleItemTouchEnd);
  }
  if (handleItemTouchMove !== undefined) {
    tmp$1.onTouchMove = Caml_option.valFromOption(handleItemTouchMove);
  }
  if (handleItemTouchStart !== undefined) {
    tmp$1.onTouchStart = Caml_option.valFromOption(handleItemTouchStart);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(DataAttribute$Showside.make, {
    dataTestId: "nav-menu-topbar-item",
    children: React.createElement("a", tmp$1, React.createElement("span", undefined, category.title))
  }), enableHiddenLinkTree ? React.createElement(make, {
    category: category
  }) : null);
}
NavMenu__Topbar$Item.displayName = "NavMenu__Topbar.Item";
var Item = {
  make: NavMenu__Topbar$Item
};
function NavMenu__Topbar(Props) {
  var itemsOpt = Props.items;
  var classNameOpt = Props.className;
  var offsetOpt = Props.offset;
  var hideOnEmptyOpt = Props.hideOnEmpty;
  var centeredOpt = Props.centered;
  var enableHiddenLinkTreeOpt = Props.enableHiddenLinkTree;
  var onMouseLeave = Props.onMouseLeave;
  var onMouseEnter = Props.onMouseEnter;
  var items = itemsOpt !== undefined ? itemsOpt : [];
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var offset = offsetOpt !== undefined ? offsetOpt : 0;
  var hideOnEmpty = hideOnEmptyOpt !== undefined ? hideOnEmptyOpt : false;
  var centered = centeredOpt !== undefined ? centeredOpt : true;
  var enableHiddenLinkTree = enableHiddenLinkTreeOpt !== undefined ? enableHiddenLinkTreeOpt : false;
  ConfigurationProvider$Showside.use(undefined);
  var ctx = NavMenu__Context$Showside.use(undefined);
  var scrollableRef = React.useRef(null);
  var items$1 = Belt_Array.keep(items, function (item) {
    return !item.isHidden;
  });
  var isEmpty = Belt_Array.keep(items$1, function (item) {
    return !item.isIndex;
  }).length === 0;
  var slides = Belt_Array.map(items$1, function (param) {
    var category = param.category;
    return React.createElement(NavMenu__Topbar$Item, {
      category: category,
      link: param.link,
      enableHiddenLinkTree: enableHiddenLinkTree,
      scrollableRef: scrollableRef,
      key: category.id
    });
  });
  var activeItemIndex = Belt_Array.getIndexBy(items$1, function (item) {
    return Caml_obj.equal(item.category.id, Belt_Option.map(ctx.currentL1, function (c) {
      return c.id;
    }));
  });
  var match = React.useState(function () {});
  var setActiveItemIndexDelayed = match[1];
  var activeItemIndexDelayed = match[0];
  React.useEffect(function () {
    var timeout = setTimeout(function (param) {
      Curry._1(setActiveItemIndexDelayed, function (param) {
        return activeItemIndex;
      });
    }, 0);
    return function (param) {
      clearTimeout(timeout);
    };
  }, [activeItemIndex]);
  var slideToIndexRef = React.useRef(function (param) {});
  React.useEffect(function () {
    var match = ctx.mode;
    if (match && activeItemIndexDelayed !== undefined) {
      Curry._1(slideToIndexRef.current, activeItemIndexDelayed);
    }
  }, [activeItemIndexDelayed]);
  if (isEmpty && hideOnEmpty) {
    return null;
  }
  var tmp = {
    className: Cn.make(["swiper-small-navigation", CSS$Showside.prefix("h-full flex items-center")])
  };
  if (onMouseEnter !== undefined) {
    tmp.onMouseEnter = Caml_option.valFromOption(onMouseEnter);
  }
  if (onMouseLeave !== undefined) {
    tmp.onMouseLeave = Caml_option.valFromOption(onMouseLeave);
  }
  var match$1 = ctx.mode;
  return React.createElement("div", tmp, React.createElement(SimpleSlider$Showside.make, {
    slides: slides,
    slidesOffsetBefore: offset,
    slidesOffsetAfter: offset,
    shouldCenter: centered,
    className: CSS$Showside.prefix("w-full"),
    ulClassName: Cn.make([match$1 ? CSS$Showside.prefix("space-x-3") : CSS$Showside.prefix("space-x-6"), className]),
    fwdRef: scrollableRef,
    slideToIndexRef: slideToIndexRef
  }));
}
NavMenu__Topbar.displayName = "NavMenu__Topbar";
var hoverDelay = 100;
var make$1 = NavMenu__Topbar;
export { hoverDelay, HiddenLinkTree, Item, make$1 as make };
/* make Not a pure module */